import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios, validURL } from "src/components/common/functions";
import { appendField } from "src/components/common/FilterFrame/FilterField";
import { fields } from "./OrganizationFilterForm";
import { saveAs } from "file-saver";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";
import { extraFields } from "./OrganizationList";

export async function organizationsLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const formData = new FormData();
    formData.append("page", url.searchParams.get("page")!);
    formData.append("limit", url.searchParams.get("limit")!);
    for (const field of fields) {
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: "organizations/readOrganizations.php", 
        formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    return res.data;
}

export async function organizationLoader({ params, request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    if (!id) {
    throw redirect(`/Organizations`);
    }
    const formData = new FormData();
    formData.append("id", id);
    const res = await myAxios({
        fileName: "organizations/readOrganization.php",
        formData, 
        signal: controller.signal
    });
    if (!res || !res.data) throw redirect("..");
    return {
        organization: res.data
    };
}
const urlMap = { "Add": "organizations/createOrganization.php", "Edit": "organizations/updateOrganization.php" };

export async function organizationAction({
    request
}: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const action = formData.get("action") as keyof typeof urlMap;
    const url = urlMap[action];
    if(!url){
        window.alert("Invalid Keyword");
        return;
    }
    if(formData.get("website") && !validURL(formData.get("website") as string)){
        window.alert("Invalid Webiste Format");
        return;
    }
    if(formData.get("website") && !formData.get("force")){
        const res0 = await myAxios({ fileName: "organizations/checkDuplicateOrganization.php", formData, signal: controller.signal });
        if(!res0) return;
        if(res0.data.length){
            return {
                duplicate: true,
                data: res0.data
            };
        }
    }
    const res = await myAxios({ fileName: url, formData, signal: controller.signal });
    if(!res) return;
    if(action === "Add"){
        return redirect(`/Organizations/${res.data.id}`);
    }
    return redirect("..");
}

export async function deleteOrganizationAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    const res = await myAxios({
        fileName: "organizations/deleteOrganization.php",
        formData: formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}

export async function voidOrganizationAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "organizations/voidOrganization.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function validateOrganizationAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "organizations/validateOrganization.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function organizationExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: `/organizations/exportOrganizations.php`,
        formData, 
        responseType: "blob", 
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "organizions.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}